var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8989 19.5L9.75 5.35113C9.44046 5.0557 9.02902 4.89086 8.60113 4.89086C8.17323 4.89086 7.76179 5.0557 7.45225 5.35113L5.35113 7.45225C5.04688 7.75719 4.87602 8.17037 4.87602 8.60113C4.87602 9.03189 5.04688 9.44506 5.35113 9.75L19.4992 23.8989C19.8041 24.2031 20.2173 24.374 20.6481 24.374C21.0788 24.374 21.492 24.2031 21.7969 23.8989L23.8989 21.7977C24.2035 21.493 24.3747 21.0798 24.3747 20.6489C24.3747 20.218 24.2035 19.8047 23.8989 19.5ZM6.5 8.60113L8.60113 6.5L12.6636 10.5625L10.5617 12.6644L6.49919 8.60194L6.5 8.60113ZM20.6481 22.75L11.7106 13.8133L13.8125 11.7114L22.75 20.6489L20.6481 22.75ZM1.625 13L3.25 11.375L4.875 13L3.25 14.625L1.625 13ZM11.375 3.25L13 1.625L14.625 3.25L13 4.875L11.375 3.25ZM1.625 3.25L3.25 1.625L4.875 3.25L3.25 4.875L1.625 3.25Z",
    fill: "#E148A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWand);
export default __webpack_public_path__ + "static/media/wand.a194920328ad11b777bfed3d3c00a0a3.svg";
export { ForwardRef as ReactComponent };